module.exports = __webpack_public_path__ + "img/search.b590222e.svg";